import BackendService from "../../service/BackendService";

class AssessmentRoundRepository {
  constructor() {
    this.backendService = new BackendService("rounds");
  }

  async getAssessmentRoundsBySchoolId(id) {
    const assessmentRound = await this.backendService.getManyByFieldId(
      "school",
      id
    );

    return assessmentRound;
  }

  async getAssessmentRoundById(id) {
    const assessmentRound = await this.backendService.getOne(id);
    return assessmentRound;
  }

  async addAssessmentRound(params) {
    return await this.backendService.addOne(params);
  }

  async deleteRound(id) {
    return await this.backendService.deleteOne(id);
  }

  async bulkCreateAssessmentRounds(params) {
    const apiUrl = this.backendService.baseUrl + "rounds/bulk-create";
    const accessToken = this.backendService.getAccessToken();
    const options = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    const { data } = await this.backendService.instance.post(
      apiUrl,
      params,
      options
    );
    return data;
  }
}
export default AssessmentRoundRepository;
